export const UPDATE_OUTAGE_DATA = 'outage/UPDATE_OUTAGE_DATA';
export const UPDATE_OUTAGE_STATUS = 'outage/UPDATE_OUTAGE_STATUS';
export const UPDATE_BACKDOOR_CODE_USAGE = 'outage/UPDATE_BACKDOOR_CODE_USAGE';
const SET_OUTAGE_DATA = 'outage/SET_OUTAGE_DATA';
const SET_OUTAGE_STATUS = 'outage/SET_OUTAGE_STATUS';
const SET_BACKDOOR_CODE_USAGE = 'outage/SET_BACKDOOR_CODE_USAGE';

export const outageStore = {
  state: {
    outageSetting: null,
    isOutage: false,
    lastUpdatedOn: null,
    backdoorCodeUsedOn: null,
  },
  mutations: {
    [SET_OUTAGE_DATA](state, outage) {
      state.outageSetting = outage;
      if (outage) { state.outageLastCheckedOn = new Date(); }
    },
    [SET_OUTAGE_STATUS](state, status) {
      state.isOutage = status;
    },
    [SET_BACKDOOR_CODE_USAGE](state, usage) {
      state.backdoorCodeUsedOn = usage;
    },
  },
  getters: {
    outageSetting: (state) => state.outageSetting,
    isOutage: (state) => state.isOutage,
    outageLastCheckedOn: (state) => state.outageLastCheckedOn,
    backdoorCodeUsedOn: (state) => state.backdoorCodeUsedOn,
  },
  actions: {
    [UPDATE_OUTAGE_DATA]: async ({ commit }, outageData) => {
      commit(SET_OUTAGE_DATA, outageData);
    },

    [UPDATE_OUTAGE_STATUS]: async ({ commit }, status) => {
      commit(SET_OUTAGE_STATUS, status);
    },
    [UPDATE_BACKDOOR_CODE_USAGE]: async ({ commit }, usage) => {
      commit(SET_BACKDOOR_CODE_USAGE, usage);
    },
  },
};
